export default __webpack_public_path__ + "static/media/toy-puddle0.8b0ef641.jpg";